import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetAmbassadorInfoService {

  constructor(private http: HttpClient) { }

  async getAmbassadorInf() {
    try {
      let response = await this.http
        .get(`${appApiResources.getAmbassadorInfo}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}